module.exports = __webpack_public_path__ + "img/14_Distal-D.21e1f4dc.png";